module.exports = __webpack_public_path__ + "media/images/recruitment/blog/blog-3-b70689c63b47e4b7104fea7626194517.jpg";